import BybVrSlider from "@Components/game/common/dialog/byb-vr-slider";
import { GameModeCard } from "@Components/game/game-mode";
import { usePractiseContext } from "@Context/game/practise/practise-context";
import { AnalyticsEvents } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";

const GameSpeedConfig = () => {
  const { i18n } = useI18n();
  const { sessionOptions, setSessionOptions } = usePractiseContext();
  const { track } = useAnalytics();

  const handleGameSpeedChange = (event: Event, newValue: number | number[]) => {
    track(AnalyticsEvents.practice_settings_adjusted, { game_speed: newValue }); //todo: add previous value
    setSessionOptions({
      ...sessionOptions,
      game_speed: newValue as number,
    });
  };

  return (
    <GameModeCard>
      <Stack spacing={1.5}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="text1xl500" color="dsNeutral.v300">
            {i18n("practice.game.speed")}
          </Typography>
          <Typography variant="text1xl500" color="dsBase.v200">
            {sessionOptions.game_speed}%
          </Typography>
        </Stack>
        <BybVrSlider value={sessionOptions.game_speed} onChange={handleGameSpeedChange} min={50} max={120} step={5} />
      </Stack>
    </GameModeCard>
  );
};

export default GameSpeedConfig;
